import GoogleMapsAutocomplete from './google-maps-autocomplete.svg';
import GoogleMapsContributorReviews from './google-maps-contributor-reviews-scraper.svg';
import GoogleMapsDataScraper from './google-maps-data-scraper.svg';
import GoogleMapsDirectoryPlaces from './google-maps-directory-places.svg';
import GoogleMapsPhotosScraper from './google-maps-photos-scraper.svg';
import GoogleMapsReviewsMonitoring from './google-maps-reviews-monitoring.svg';
import GoogleMapsReviewsScraper from './google-maps-reviews-scraper.svg';
import GoogleMapsReviewsSentimentAnalysis from './google-maps-reviews-sentiment-analysis.svg';
import GoogleMapsReviewsSummary from './google-maps-reviews-summary.svg';
import GoogleMapsSearchByDomains from './google-maps-search-by-domains.svg';
import GoogleMapsTrafficScraper from './google-maps-traffic-scraper.svg';
import GooglePlayReviewsMonitoring from './googleplay-reviews-monitoring.svg';
import GooglePlayReviewsScraper from './google-play-reviews-scraper.svg';
import GoogleSearchAutocomplete from './google-search-autocomplete.svg';
import GoogleSearchCareers from './google-search-careers.svg';
import GoogleSearchEventsScraper from './google-search-events-scraper.svg';
import GoogleSearchFlightsScraper from './google-search-flights-scraper.svg';
import GoogleSearchImagesScraper from './google-search-images-scraper.svg';
import GoogleSearchJobs from './google-search-jobs.svg';
import GoogleSearchNewsScraper from './google-search-news-scraper.svg';
import GoogleSearchScraper from './google-search-scraper.svg';
import GoogleSearchShoppingScraper from './google-search-shopping-scraper.svg';
import GoogleSearchVideosScraper from './google-search-videos-scraper.svg';
import GoogleShoppingReviewsScraper from './google-shopping-reviews-scraper.svg';
import GoogleTrendsScraper from './google-trends-scraper.svg';

export const googleIcons = {
  GoogleMapsAutocomplete,
  GoogleMapsContributorReviews,
  GoogleMapsDataScraper,
  GoogleMapsDirectoryPlaces,
  GoogleMapsPhotosScraper,
  GoogleMapsReviewsMonitoring,
  GoogleMapsReviewsScraper,
  GoogleMapsReviewsSentimentAnalysis,
  GoogleMapsReviewsSummary,
  GoogleMapsSearchByDomains,
  GoogleMapsTrafficScraper,
  GooglePlayReviewsMonitoring,
  GooglePlayReviewsScraper,
  GoogleSearchAutocomplete,
  GoogleSearchCareers,
  GoogleSearchEventsScraper,
  GoogleSearchFlightsScraper,
  GoogleSearchImagesScraper,
  GoogleSearchJobs,
  GoogleSearchNewsScraper,
  GoogleSearchScraper,
  GoogleSearchShoppingScraper,
  GoogleSearchVideosScraper,
  GoogleShoppingReviewsScraper,
  GoogleTrendsScraper
};
